import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-modal w-maxC" }
const _hoisted_2 = { class: "row w-full" }
const _hoisted_3 = {
  key: 1,
  class: "w-full"
}
const _hoisted_4 = { class: "grid mtop-10" }
const _hoisted_5 = {
  style: {"grid-column":"1"},
  class: "rowend"
}
const _hoisted_6 = { class: "grid-column: 2; row" }
const _hoisted_7 = {
  style: {"grid-column":"1"},
  class: "rowend"
}
const _hoisted_8 = { class: "grid-column: 2;" }
const _hoisted_9 = {
  style: {"grid-column":"1","margin-top":"1.1rem"},
  class: "rowend"
}
const _hoisted_10 = { class: "grid-column: 2;" }
const _hoisted_11 = {
  style: {"grid-column":"1"},
  class: "rowend"
}
const _hoisted_12 = { style: {"grid-column":"2"} }

import { ref, onMounted, onUnmounted, computed } from 'vue';
import { useCurrentEntryStore } from '@/stores/currentEntry';
import relationshipapi from "@/api/relationshipapi";
import { useRoute } from 'vue-router';
import { useAppUserStore } from '@/stores/appUser'
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'mrInput',
  props: {
  cnsReferenceDr: {
    type: Object,
    required: false,
  },
  pwrPatient: {
    type: Object,
    required: false,
  },
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();

const appUserStore = useAppUserStore()

const props = __props

const currentEntryStore = useCurrentEntryStore();
const emits = __emit;
const focusRef = ref(null);
const route = useRoute();

const currentHealthPro = computed(() => appUserStore.getHealthProNameWithTitle());

async function deleteLuCnsReferenceDr() {
  if (!props.cnsReferenceDr) return;
  noUpdate.value = false
  const cnsReferenceDrId = props.cnsReferenceDr.relationshipId
  await relationshipapi.deleteLuCnsReferenceDr(cnsReferenceDrId)
  await currentEntryStore.reloadPatientOnly();
  emits("close")  
}

const initialDeclarationDate = ref(props.cnsReferenceDr?.declarationDate || "")
const currentDeclarationDate = ref(initialDeclarationDate.value)
function changeDeclarationDate(newIso: any) {
  currentDeclarationDate.value = newIso
}
async function updateDeclarationDate() {
  if (initialDeclarationDate.value === currentDeclarationDate.value) return false;
  const cnsReferenceDrId = props.cnsReferenceDr.relationshipId
  const newText = currentDeclarationDate.value
  await relationshipapi.updateLuCnsReferenceDrDeclarationDate(cnsReferenceDrId, newText).then(() => {
    currentEntryStore.modalPatient.cnsReferenceDr.declarationDate = currentDeclarationDate.value;
  })
  return true;
}

const declarationNumberInput = ref(props.cnsReferenceDr?.cnsReferenceDrNumber || "")
async function updateLuCnsDeclarationNumber() {
  if (props.cnsReferenceDr.cnsReferenceDrNumber === declarationNumberInput.value) return false;
  const cnsReferenceDrId = props.cnsReferenceDr.relationshipId
  const newText = declarationNumberInput.value
  await relationshipapi.updateLuCnsReferenceDrDeclarationNumber(cnsReferenceDrId, newText).then(() => {
    currentEntryStore.modalPatient.cnsReferenceDr.cnsReferenceDrNumber = declarationNumberInput.value;
  })
  return true;
}

const referenceDrMainInput = ref(props.cnsReferenceDr?.referenceDrMain || "")
function addCurrentAppUserAsMain() {
  referenceDrMainInput.value = currentHealthPro.value;
}

async function updateLuCnsReferenceDrMain() {
  if (props.cnsReferenceDr.referenceDrMain === referenceDrMainInput.value) return false;
  const cnsReferenceDrId = props.cnsReferenceDr.relationshipId
  const newText = referenceDrMainInput.value
  await relationshipapi.updateLuCnsReferenceDrMain(cnsReferenceDrId, newText).then(() => {
    currentEntryStore.modalPatient.cnsReferenceDr.referenceDrMain = referenceDrMainInput.value;
  })
  return true;
}


const referenceDrReplacementInput = ref(props.cnsReferenceDr?.referenceDrReplacement || "")
async function updateLuCnsReferenceDrReplacement() {
  if (props.cnsReferenceDr.referenceDrReplacement === referenceDrReplacementInput.value) return false;
  const cnsReferenceDrId = props.cnsReferenceDr.relationshipId
  const newText = referenceDrReplacementInput.value
  await relationshipapi.updateLuCnsReferenceDrReplacement(cnsReferenceDrId, newText).then(() => {
    currentEntryStore.modalPatient.cnsReferenceDr.referenceDrReplacement = referenceDrReplacementInput.value;
  })
  return true;
}


async function addLuCnsReferenceDrToPwr() {
  if (props.cnsReferenceDr) return;
  console.log(props.pwrPatient)
  const pwrPatientId = props.pwrPatient.personWithRoleId
  const referenceDrMain = referenceDrMainInput.value
  const referenceDrReplacement = referenceDrReplacementInput.value;
  const declarationDate = currentDeclarationDate.value || ""
  const declarationNumber = declarationNumberInput.value
  await relationshipapi.addLuCnsReferenceDrToPwr(pwrPatientId, referenceDrMain, referenceDrReplacement, declarationNumber, declarationDate)
  await currentEntryStore.reloadPatientOnly();
  emits("close")
}

onMounted(() => {
  focusRef.value.innerRef.focus()
})

const noUpdate = ref(false)
onUnmounted(async () => {
  if (noUpdate.value || !props.cnsReferenceDr) return;
  let updated = false
  updated = await updateLuCnsReferenceDrMain() || updated
  updated = await updateLuCnsReferenceDrReplacement() || updated
  updated = await updateLuCnsDeclarationNumber() || updated
  updated = await updateDeclarationDate() || updated
  if (updated) await currentEntryStore.reloadPatientOnly();
})


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_inputLineNew2 = _resolveComponent("inputLineNew2")!
  const _component_inputBox = _resolveComponent("inputBox")!
  const _component_inputNewDate = _resolveComponent("inputNewDate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_text_item, {
          txt: _unref(t)('patient.admin.referringDoctor.title'),
          styles: "font-l"
        }, null, 8, ["txt"])
      ]),
      (props.cnsReferenceDr)
        ? (_openBlock(), _createBlock(_component_buttonGroup, {
            key: 0,
            styles: "rnd-m",
            class: "mleft-08",
            style: {"margin-top":"-0.2rem"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteLuCnsReferenceDr()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_svg_item, {
                icon: "trash",
                styles: "main-l"
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_buttonGroup, {
              class: "padButton-m",
              styles: "border-h",
              style: {"margin-left":"auto"},
              onClick: _cache[1] || (_cache[1] = ($event: any) => (addLuCnsReferenceDrToPwr()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_text_item, {
                  txt: _unref(t)('action.create'),
                  styles: "font-mBold main-h"
                }, null, 8, ["txt"])
              ]),
              _: 1
            })
          ]))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_text_item, {
          txt: _unref(t)('patient.admin.referringDoctor.main.short'),
          styles: "main-m align-r"
        }, null, 8, ["txt"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_inputBox, null, {
          default: _withCtx(() => [
            _createVNode(_component_inputLineNew2, {
              ref_key: "focusRef",
              ref: focusRef,
              modelValue: referenceDrMainInput.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((referenceDrMainInput).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_buttonGroup, {
          styles: "rnd-m border-l",
          class: "mleft-08",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (addCurrentAppUserAsMain()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_text_item, {
              txt: _unref(t)('common.me'),
              styles: "main-m"
            }, null, 8, ["txt"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_text_item, {
          txt: _unref(t)('patient.admin.referringDoctor.second.short'),
          styles: "main-m align-r"
        }, null, 8, ["txt"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_inputBox, null, {
          default: _withCtx(() => [
            _createVNode(_component_inputLineNew2, {
              modelValue: referenceDrReplacementInput.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((referenceDrReplacementInput).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "mtop-10" }, null, -1)),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_text_item, {
          txt: _unref(t)('patient.admin.referringDoctor.initialDeclarationDate'),
          styles: "main-m"
        }, null, 8, ["txt"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_inputNewDate, {
          dateIso: initialDeclarationDate.value,
          isNew: !__props.cnsReferenceDr?.declarationDate,
          calendar: false,
          trash: true,
          onChanged: changeDeclarationDate,
          onDelete: _cache[5] || (_cache[5] = ($event: any) => (changeDeclarationDate('')))
        }, null, 8, ["dateIso", "isNew"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_text_item, {
          txt: _unref(t)('patient.admin.referringDoctor.declarationNumber'),
          styles: "main-m align-r"
        }, null, 8, ["txt"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_inputBox, null, {
          default: _withCtx(() => [
            _createVNode(_component_inputLineNew2, {
              modelValue: declarationNumberInput.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((declarationNumberInput).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})